declare const __BUILD_BRANCH__: string;

const PROD_CB_URL = 'https://myra-cb.makemytrip.com/platform-mmt-ai-cb';
const NEW_SERVER_CB_URL = 'https://prodppmypartnerapi.makemytrip.com/platform-mmt-ai-cb';

function resolveCbBackendUrl(): string {
  // Build-time: --branch=release means production
  if (__BUILD_BRANCH__ === 'release') return PROD_CB_URL;

  // Runtime fallback: check hostname
  const hostname = globalThis.location?.hostname ?? '';
  if (hostname === 'www.makemytrip.com') return PROD_CB_URL;

  return NEW_SERVER_CB_URL;
}

export const CB_BACKEND_URL = resolveCbBackendUrl();

//staging
// export const CB_BACKEND_URL =
//   import.meta.env['VITE_CB_BACKEND_URL'] ??
//   'https://stagingmypartnerapi.makemytrip.com/platform-mmt-ai-cb';

//local development
// export const CB_BACKEND_URL =
//   import.meta.env['VITE_CB_BACKEND_URL'] ?? 'http://localhost:8080/platform-mmt-ai-cb';

if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>)['__BUILD_INFO__'] = {
    branch: __BUILD_BRANCH__,
    cbBackendUrl: CB_BACKEND_URL,
  };
}

// ============================================================================
// Voice WebSocket Configuration
// ============================================================================
/** Voice WebSocket endpoint for speech-to-text */
const CB_LIVE_URL = 'https://platform-mmt-ai-cb.mmt.live/platform-mmt-ai-cb';
export const VOICE_WS_URL = `${CB_LIVE_URL}/ws/voice`;

/** Supported languages for voice recognition */
export type VoiceLanguage =
  | 'en-IN' // English (India) - Default
  | 'hi-IN' // Hindi
  | 'bn-IN' // Bengali
  | 'ta-IN' // Tamil
  | 'te-IN' // Telugu
  | 'mr-IN' // Marathi
  | 'kn-IN' // Kannada
  | 'ml-IN'; // Malayalam

/** Default voice language */
export const DEFAULT_VOICE_LANGUAGE: VoiceLanguage = 'en-IN';
